import { render, staticRenderFns } from "./iva-ventas.vue?vue&type=template&id=2c6d3ff0&scoped=true"
import script from "./iva-ventas.vue?vue&type=script&lang=js"
export * from "./iva-ventas.vue?vue&type=script&lang=js"
import style0 from "./iva-ventas.vue?vue&type=style&index=0&id=2c6d3ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6d3ff0",
  null
  
)

export default component.exports